import * as _ from "lodash";

export interface SchoolWorkloadConfig
{
    sdsStartDate: Date;
    sdsEndDate: Date;
    subjectsConfig: SubjectsConfig;
    subjectExcludes: SubjectExcludes;
    yearGroupings: YearGroupings;
    departments: Departments;
    extraTeamsConfig: ExtraTeamsConfig;
}

export interface SubjectsConfig
{
    megamenuMyListName: string;
    showNotebookInQuicklinks: boolean;
    useSubsites: boolean;
}



export interface SubjectExcludes {
    sourceSubjectCodes: string[];
}

export interface YearGroupings {
    aggregatePermissions: boolean;
    items: YearGrouping[];
}

export interface YearGrouping {
    [key: string] : any;
    
    name: string;
    isAfter: string | null;
    years: string[];
}

export interface Departments {
    enableSchoolCodePrefix: boolean;
    items: Department[];
}

export interface Department {
    [key: string] : any;

    rawName: string,
    staffTemplate: boolean;
    sourceSubjectCodes: string[];
}

export interface ExtraTeamsConfig {
    enableAllTeachersTeam: boolean;
    enableAllStaffTeam: boolean;
}

export const sortYearGroupingsByIsAfterValues = (yearGroupings: YearGrouping[]): YearGrouping[] =>
{
    const isAfterValues = yearGroupings.filter(yg => yg.isAfter).map(yg => yg.isAfter!);
    let currentYearGrouping = yearGroupings.filter(yg => !yg.isAfter && _.includes(isAfterValues,yg.name))[0];
    if(!currentYearGrouping)
    {
        console.log("Can't find root year grouping, not sorting year groupings");
        return _.clone(yearGroupings)
    }
    
    const sortedYearGroupings: YearGrouping[] = [];
    
    while(currentYearGrouping)
    {
        sortedYearGroupings.push(currentYearGrouping)
        currentYearGrouping = yearGroupings.filter(yg => yg.isAfter === currentYearGrouping.name)[0];
    }
    
    const remainingUnsortedYearGroupings = _.difference(yearGroupings,sortedYearGroupings);
    return _.concat(sortedYearGroupings,remainingUnsortedYearGroupings);
}

export const applySortOrderToYearGroupingIsAfterValues = (yearGroupings: YearGrouping[]): void => {
    
    let previousYearGrouping = undefined;
    for(const yearGrouping of yearGroupings)
    {
        if(previousYearGrouping)
        {
            yearGrouping.isAfter = previousYearGrouping.name;
        }
        else
        {
            yearGrouping.isAfter = null;
        }

        previousYearGrouping = yearGrouping;
    }

};